/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function ColorBlindDeuteranomaly(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'ColorBlindDeuteranomaly',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M2.172 13.828a4.03 4.03 0 0 0 2.276 1.145l-3.421-3.42a4.03 4.03 0 0 0 1.145 2.275M1.117 9.945l4.938 4.938c.443-.116.869-.31 1.257-.581L1.698 8.688a4 4 0 0 0-.581 1.257m1.408-2.127a4 4 0 0 1 1.202-.637l5.092 5.093a4 4 0 0 1-.637 1.2L2.525 7.819zm2.711-.825 3.771 3.771a4.03 4.03 0 0 0-1.178-2.592 4.03 4.03 0 0 0-2.593-1.179","fill":"#2FC862"}),createElement('path', {"d":"M9.346 14.371A5.48 5.48 0 0 0 10.5 11c0-1.27-.43-2.44-1.154-3.371a4 4 0 1 1 0 6.742","fill":"#2496FF"}),createElement('path', {"d":"M9.909 8.516a4 4 0 1 0-5.866-2.933 5.5 5.5 0 0 1 5.866 2.933","fill":"#FF424D"}))
}
